import { PLUGIN_LOGO_ICON_COMPONENTS } from "metabase/plugins";

interface LogoIconProps {
  width?: number;
  height?: number;
  dark?: boolean;
  fill?: string;
}

// IAS overlay: swap the Metabase dots inline SVG for the IAS main-logo asset.
// `dark` requests the light-on-dark variant used on colored headers (e.g. the
// admin app bar); everywhere else we use the tinted version. Callers pass
// either `height` or `width`; we let the browser derive the other so the SVG's
// aspect ratio is preserved.
export const DefaultLogoIcon = ({
  dark,
  height = 32,
  width,
}: LogoIconProps) => {
  const src = dark
    ? "/app/assets/img/main-logo-white.svg"
    : "/app/assets/img/main-logo.svg";
  return (
    <img
      src={src}
      alt="Insights"
      height={height}
      width={width}
      data-testid="main-logo"
      style={{ height, width }}
    />
  );
};

export function LogoIcon(props: LogoIconProps) {
  const [Component = DefaultLogoIcon] = PLUGIN_LOGO_ICON_COMPONENTS;
  return <Component {...props} />;
}
